import { Switch } from "@/components/ui/switch";
import { Validate2FAStep, useValidate2FA } from "@/hooks/useValidate2FA";
import { useEffect, useState } from "react";
import { t } from "i18next";
import { toast } from "@/hooks/use-toast";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import OTPInput from "@/components/ui/otp-input";

const SwitchAuthentication = (): JSX.Element => {
  const [code, setCode] = useState<string>("");
  const [password, setPassoword] = useState<string>("");
  const {
    enabled,
    step,
    toggle2FA,
    confirmVerificationCode,
    confirmPassword,
    error,
    loading,
    close2FADialog,
  } = useValidate2FA();

  useEffect(() => {
    if (error) {
      toast({
        variant: "error",
        title: "Error",
        description: `${error}`,
      });
    }
  }, [error]);

  const handleClose = (): void => {
    setCode("");
    setPassoword("");
    close2FADialog();
  };

  const handleSubmit = async (): Promise<void> => {
    if (step == Validate2FAStep.enterPassword) {
      await confirmPassword(password);
    } else if (step == Validate2FAStep.VerfifySMS) {
      await confirmVerificationCode(code);
    }
  };

  return (
    <div className="space-y-0">
      <div className="flex items-center justify-between">
        <Label className="text-md">{t("settings.security.2FA")}</Label>
        <Switch checked={enabled} onCheckedChange={toggle2FA} />
      </div>
      {step != Validate2FAStep.Idle && (
        <Dialog open modal={false} onOpenChange={handleClose}>
          <div id="recaptcha-container"></div>
          <div className="fixed inset-0 bg-black bg-opacity-80 z-40" />
          <DialogContent className="bg-background p-6 rounded-lg shadow-md max-w-sm w-full max-h-[90vh] overflow-y-auto fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 [&>button]:hidden">
            {step == Validate2FAStep.enterPassword && (
              <>
                <DialogHeader>
                  <DialogTitle className="text-center">
                    {t(
                      "settings.account.components.switchAuthentication.password.description"
                    )}
                  </DialogTitle>
                  <DialogDescription className="hidden"></DialogDescription>
                </DialogHeader>
                <div className="space-y-2 mt-2">
                  {step == Validate2FAStep.enterPassword && (
                    <Input
                      className="w-full border p-2 rounded-md"
                      type="password"
                      value={password}
                      onChange={(event) => {
                        setPassoword(event.target.value);
                      }}
                    />
                  )}
                </div>
              </>
            )}
            {step == Validate2FAStep.VerfifySMS && (
              <>
                <DialogHeader>
                  <DialogTitle className="text-center">
                    {t(
                      "settings.account.components.switchAuthentication.otp.description"
                    )}
                  </DialogTitle>
                  <DialogDescription className="hidden"></DialogDescription>
                </DialogHeader>
                <div className="space-y-2 mt-6">
                  <OTPInput length={6} onChangeOTP={setCode} />
                </div>
              </>
            )}
            <DialogFooter>
              <div className="w-full flex justify-between space-x-2">
                <DialogClose asChild>
                  <Button type="button" variant={"outline"}>
                    {t(
                      "settings.account.components.switchAuthentication.cancel"
                    )}
                  </Button>
                </DialogClose>
                <Button disabled={loading} type="submit" onClick={handleSubmit}>
                  {loading && <Loader2 className="animate-spin" />}
                  {t("settings.account.components.switchAuthentication.next")}
                </Button>
              </div>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default SwitchAuthentication;
